import React from "react";
import "./SteelIndustryChain.css";
import steelimg from "./steelndustry.jpg";

const SteelIndustryChain = () => {
  return (
    <div className="main-steel">
      <div className="second-steel">
        <div className="industry">
          <p>Steel Industry Chain</p>
          <div>
            <p className="stee2">
              Swajit Engineering Pvt.Ltd.>Steel Industry Chain
            </p>
          </div>
        </div>
        <div className="steelindustry">
          <h3 className="teel">
            Are you looking for the best Steel Industry Chain manufacturers in
            India?
          </h3>
          <p>
            We at Swajit engineering Pvt ltd are leading one of the <b> Steel
            industry Chain Manufacturers in Aurangabad, Maharashtra India. </b>
            Equipped with modern machinery and technologies, our professional
            team produces the highest quality conveyor chains and chains such as
            belts, drag, scrappers, sprockets, or roller chains used in the
            steel industry. These conveyor chains are broadly used for moving or
            shifting heavy-duty steel materials, boxes, and loads from one
            location to another in the steel industry.
          </p>

          <div className="steel-chain">
            <img src={steelimg} alt="img"></img>

            <div className="steel-chain1">
              <div className="steel-chain2">
                <p>
                  Having vast knowledge in the domain of the steel industry, we
                  are highly engaged in supplying an extensive assortment of
                  conveyor chains for the steel industry on timely delivery. Our
                  chains are highly durable in nature that are retained for a
                  longer time. Moreover, the chains are corrosion resistant,
                  have high tensile strength, operate smoothly, and perform
                  excellently with high efficiency. Our esteemed clients can
                  avail several types of conveyor chains from us at a reasonable
                  rate. Hence, our industry is known as one of the best{" "}
                  <b>Steel Industry Chain manufacturers in India.</b>
                </p>
              </div>
            </div>
          </div>

          <div className="steel-chain3">
            <h4>Chains are provided by us for the steel industry:</h4>
            <ul>
              <li>Roller chains </li>
              <li>Sprockets</li>
              <li>Drive chains</li>
              <li>Extend pin roller chain</li>
              <li>Slate conveyor chain</li>
              <li>Bucket elevator</li>
              <li>Drag chain conveyor</li>
              <li>Industrial roller chains</li>
            </ul>
            <h4>Key features:</h4>
            <ul>
              <li>High strength</li>
              <li>Robust construction</li>
              <li>Wide variety of sizes and shapes</li>
              <li>Costs effective</li>
            </ul>
            <p>Contact us on 9922941689 or Email marketing@swajit.com.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SteelIndustryChain;
